export default __webpack_public_path__ + "static/media/main_register.ed5263da.svg";